/**
 * v0.3 (S-6.5) 開発専用: 最長表示モード
 * 設計: docs/design/v03-sidebar-review-2026-08-04.md (process-01)
 *
 * 「ラベルが2行になった時だけアイコンと重なる」等、崩れは常に条件(長いテキスト)が揃った時だけ
 * 現れるため、通常の目視レビューでは構造的に検出できない。localStorage.setItem('__maxlen','1') を
 * 立ててリロードすると、ナビラベル等の対象テキストが全角ダミー文字列に差し替わり、崩れを再現できる。
 * withMaxLen/isMaxLenModeEnabled は AppLayout.tsx 等から静的importされるためモジュール自体は
 * production バンドルにも含まれるが、import.meta.env.DEV が静的にfalseになりViteが分岐を
 * 畳み込むため常にno-op (text をそのまま返す)。initDevMaxLenBadge のみ main.tsx 側で動的import
 * されておりバッジ生成コード自体がtree-shakeされる。
 */

const KEY = '__maxlen';
const BADGE_ID = 'dev-maxlen-badge';

export const isMaxLenModeEnabled = (): boolean =>
  import.meta.env.DEV && typeof window !== 'undefined' && localStorage.getItem(KEY) === '1';

const DUMMY_CHARS = 'あいうえおかきくけこさしすせそ';

/** 全角ダミー文字列をmaxLen文字で生成する (半角英数より折り返しが厳しい日本語で検証するため) */
export const dummyText = (maxLen: number): string =>
  DUMMY_CHARS.repeat(Math.ceil(maxLen / DUMMY_CHARS.length)).slice(0, maxLen);

/** 最長表示モード有効時は maxLen 文字の全角ダミーに差し替える。無効時は text をそのまま返す。
 *  対象はDBカラム定義上の最大長を持つ値についてはその値、UI固有ラベル(ナビ等)は崩れを確実に
 *  再現できる想定最大長(実データの最長より長め)を呼び出し側で指定する */
export const withMaxLen = (text: string, maxLen: number): string =>
  (isMaxLenModeEnabled() ? dummyText(maxLen) : text);

/** main.tsx (DEV限定) から1回だけ呼び出す。有効時、画面右下にバッジを表示する */
export const initDevMaxLenBadge = (): void => {
  if (!isMaxLenModeEnabled()) return;
  if (document.getElementById(BADGE_ID)) return;
  const el = document.createElement('div');
  el.id = BADGE_ID;
  el.textContent = '📏 最長表示モード';
  el.style.cssText = [
    'position:fixed', 'left:8px', 'bottom:8px', 'z-index:2147483647',
    'background:#0B2450', 'color:#fff', 'font:11px/1.4 sans-serif',
    'padding:4px 8px', 'border-radius:4px', 'box-shadow:0 2px 8px rgba(0,0,0,.3)',
    'pointer-events:none',
  ].join(';');
  document.body.appendChild(el);
};
